import '@loyal_modules/carousel/css/owl.carousel.css'
import '@loyal_modules/carousel/css/owl.theme.default.min.css'

import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import yn from 'yn'
import Helmet from 'react-helmet'

import {
  StoreSuggestion
} from 'features/Suggestion'
import { Services } from 'features/Services'
import { MenuHomeContainer } from 'App/MainMenu/MenuMobile'
import { SliderContainer, ConexxeBanner } from 'features/Slider'
import Showcase, { FilteredShowcase, CategoriesShowcase, BenefitsShowcase } from 'Catalog/Showcase'
import { AccumulatePoints } from 'features/AccumulatePoints'
import { BestOffers } from 'features/BestOffers'
import MediaQuery from 'react-responsive'
import { Mileage } from 'features/Services/Mileage'
import { ModalCategories } from './ModalCategories'

const HomePage = ({ profile }) => {
  return (
    <Fragment>
      <Helmet>
        <title>{`${process.env.REACT_APP_TITLE || ''}`}</title>
      </Helmet>
      <SliderContainer />
      {profile && yn(process.env.REACT_APP_HAS_TRADEMENU_HOME) && (
        <MenuHomeContainer />
      )}

      <Showcase showcaseType='5' identifier='home' />

      {yn(process.env.REACT_APP_HAS_BENEFITS_SHOWCASE) && <BenefitsShowcase />}
      {yn(process.env.REACT_APP_HAS_FILTERED_SHOWCASE) && <FilteredShowcase />}
      {yn(process.env.REACT_APP_HAS_CATEGORIES_SHOWCASE) && <CategoriesShowcase />}

      <MediaQuery maxWidth={1024}>
        {yn(process.env.REACT_APP_HAS_CONNEXXE_BANNER) && <ConexxeBanner />}
      </MediaQuery>
      {yn(process.env.REACT_APP_HAS_ACCUMULATE_BANNERS) && <AccumulatePoints />}
      {yn(process.env.REACT_APP_HAS_BEST_OFFERS) && <BestOffers />}
      <MediaQuery minWidth={1025}>
        {yn(process.env.REACT_APP_HAS_CONNEXXE_BANNER) && <ConexxeBanner />}
      </MediaQuery>

      {yn(process.env.REACT_APP_HAS_VOUCHER_SHOWCASE) && <Showcase showcaseType='7' identifier='home' />}
      {profile && (
        <Fragment>
          <Services />
          {yn(process.env.REACT_APP_HAS_MILEAGE) && <Mileage />}
          <ModalCategories />
        </Fragment>
      )}

      <Showcase showcaseType='5' identifier='voucher' viewAllPath='/stores/vouchers' titleFixed='Troque seu saldo por vouchers e/ou serviços.' titleMobileFixed='Troque seu saldo por vouchers e/ou serviços.' />

      {yn(process.env.REACT_APP_HAS_STORES_SHOWCASE) && <StoreSuggestion />}

    </Fragment>
  )
}

HomePage.propTypes = {
  profile: PropTypes.object
}

export default HomePage



// WEBPACK FOOTER //
// ./src/HomePage/HomePage.js